import { cn } from '@/lib/utils';

interface EventsStatCardProps {
  value: number;
  label: string;
  className?: string;
}

export function EventsStatCard({
  value,
  label,
  className,
}: EventsStatCardProps) {
  const displayLabel = value === 1 ? label : `${label}s`;
  return (
    <div
      className={cn(
        'flex-1 flex flex-col gap-1 p-3 bg-muted rounded-md',
        className,
      )}
    >
      <span className='text-lg font-bold leading-none'>{value}</span>
      <span className='text-sm text-muted-foreground leading-none'>
        {displayLabel}
      </span>
    </div>
  );
}
